import React from 'react';
import { Modal, Button } from 'antd';
import { Message } from './Messages';

type State = {
    visible: boolean,
    confirm: boolean
}

type PopUpProps = {
    actionName: string,
    unsetConfirmationPopUp: () => void,
    isActionConfirmed: (confirm: boolean) => void
}

function defaultState(): State {
    return {
        visible: true,
        confirm: false
    }
}

export default class ConfirmationPopUp extends React.Component<PopUpProps, State> {
    
    constructor(props: PopUpProps) {
        super(props);
        this.state = defaultState();
    }

    showModal = () => {
      this.setState({
        visible: true,
      });
    };
  
    handleOk = () => {
    //  console.log(e);
      this.setState({
        visible: false,
        confirm: true
      }, ()=> {
          this.props.unsetConfirmationPopUp();
          this.props.isActionConfirmed(this.state.confirm);
      });
    };
  
    handleCancel = () => {
    //  console.log(e);
      this.setState({
        visible: false,
        confirm: false
      }, ()=> {
          this.props.unsetConfirmationPopUp();
          this.props.isActionConfirmed(this.state.confirm);
      });
    };
  
    render() {
      return (
        <div>
          <Modal
            // title={this.props.actionName + " Action"}
            visible={this.state.visible}
           //  onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={[ 
                <Button onClick={this.handleCancel}>no</Button>,
                <Button onClick={this.handleOk}>yes</Button>
            ]}
          >
            <p>{ Message.CONFIRMATION_POPUP_MESSAGE }</p>
          
          </Modal>
        </div>
      );
    }
}